const portrait = {
	bg_BG: {back: "Върнете се към уебсайта", or: "ИЛИ", turn: "Моля, завъртете устройството си в пейзажен режим!"},
	cs_CZ: {back: "Přejít na web", or: "NEBO", turn: "Otočte prosím své zařízení na šířku!"},
	da_DK: {back: "Gå til hjemmesiden", or: "ELLER", turn: "Drej venligst din enhed til landskabstilstand!"},
	de_DE: {back: "Zur Website", or: "ODER", turn: "Bitte drehen Sie Ihr Gerät in den Querformat-Modus!"},
	el_GR: {back: "Μετάβαση στον ιστότοπο", or: "Ή", turn: "Γυρίστε τη συσκευή σας σε οριζόντια προβολή!"},
	en_SC: {back: "Go to the website", or: "OR", turn: "Please turn your device to landscape mode!"},
	en_US: {back: "Go to the website", or: "OR", turn: "Please turn your device to landscape mode!"},
	es_ES: {back: "Volver al sitio web", or: "O", turn: "¡Por favor, gire su dispositivo al modo paisaje!"},
	et_EE: {back: "Mine veebilehele", or: "VÕI", turn: "Palun pöörake oma seade rõhtasendisse!"},
	fa_IR: {back: "بازگشت به وب‌سایت", or: "یا", turn: "لطفاً دستگاه خود را به حالت افقی بچرخانید!"},
	fi_FI: {back: "Siirry verkkosivustolle", or: "TAI", turn: "Käännä laitteesi vaakatilaan!"},
	fr_FR: {back: "Aller sur le site", or: "OU", turn: "Veuillez tourner votre appareil en mode paysage!"},
	hr_HR: {back: "Idi na web stranicu", or: "ILI", turn: "Molimo okrenite uređaj u vodoravni položaj!"},
	hu_HU: {back: "Ugrás a weboldalra", or: "VAGY", turn: "Kérjük, fordítsa el készülékét fekvő módba!"},
	hy_AM: {back: "Անցնել կայք", or: "ԿԱՄ", turn: "Խնդրում ենք սարքը պահել հորիզոնական դիրքով!"},
	id_ID: {back: "Kembali ke situs", or: "ATAU", turn: "Silakan putar perangkat Anda ke mode lanskap!"},
	it_IT: {back: "Vai al sito web", or: "O", turn: "Ruota il dispositivo in modalità orizzontale!"},
	ja_JP: {back: "ウェブサイトへ戻る", or: "または", turn: "デバイスを横向きにしてください！"},
	ka_GE: {back: "ვებსაიტზე გადასვლა", or: "ან", turn: "გთხოვთ, მოატრიალოთ მოწყობილობა ალბომურ რეჟიმში!"},
	ko_KR: {back: "웹사이트로 이동", or: "또는", turn: "기기를 가로 모드로 전환해 주세요!"},
	lt_LT: {back: "Grįžti į svetainę", or: "ARBA", turn: "Prašome pasukti įrenginį į horizontalią padėtį!"},
	lv_LV: {back: "Doties uz vietni", or: "VAI", turn: "Lūdzu, pagrieziet ierīci ainavorientācijā!"},
	ms_MY: {back: "Pergi ke laman web", or: "ATAU", turn: "Sila putar peranti anda ke mod landskap!"},
	nb_NO: {back: "Gå til nettstedet", or: "ELLER", turn: "Vennligst snu enheten til landskapsmodus!"},
	nl_NL: {back: "Ga naar website", or: "OF", turn: "Draai je apparaat naar de liggende stand!"},
	pl_PL: {back: "Przejdź do strony", or: "LUB", turn: "Obróć urządzenie do trybu poziomego!"},
	pt_BR: {back: "Ir para o site", or: "OU", turn: "Por favor, gire seu dispositivo para o modo paisagem!"},
	pt_PT: {back: "Ir para o site", or: "OU", turn: "Por favor, gire seu dispositivo para o modo paisagem!"},
	ro_RO: {back: "Mergi la site", or: "SAU", turn: "Vă rugăm să rotiți dispozitivul în modul peisaj!"},
	ru_RU: {back: "Назад на сайт", or: "ИЛИ", turn: "Поверните устройство в ландшафтный режим!"},
	sk_SK: {back: "Prejsť na web", or: "ALEBO", turn: "Otočte zariadenie na šírku!"},
	sr_Latn: {back: "Idi na sajt", or: "ILI", turn: "Molimo okrenite uređaj u položeni položaj!"},
	sv_SE: {back: "Gå till webbplatsen", or: "ELLER", turn: "Vänligen vänd din enhet till liggande läge!"},
	th_TH: {back: "ไปที่เว็บไซต์", or: "หรือ", turn: "โปรดหมุนอุปกรณ์ของคุณเป็นแนวนอน!"},
	tr_TR: {back: "Siteye git", or: "VEYA", turn: "Lütfen cihazınızı yatay moda çevirin!"},
	uk_UA: {back: "На сайт", or: "АБО", turn: "Будь ласка, поверніть пристрій в альбомний режим!"},
	vi_VN: {back: "Đến trang web", or: "HOẶC", turn: "Vui lòng xoay thiết bị sang chế độ ngang!"},
	zh_Hans: {back: "返回网站", or: "或", turn: "请将设备切换为横屏模式！"},
	zh_Hant: {back: "返回網站", or: "或", turn: "請將裝置切換為橫向模式！"}
};

const landscape = {
	bg_BG: {back: "Върнете се към уебсайта", or: "ИЛИ", turn: "Моля, завъртете устройството си в портретен режим!"},
	cs_CZ: {back: "Přejít na web", or: "NEBO", turn: "Otočte prosím své zařízení na výšku!"},
	da_DK: {back: "Gå til hjemmesiden", or: "ELLER", turn: "Drej venligst din enhed til portrættilstand!"},
	de_DE: {back: "Zur Website", or: "ODER", turn: "Bitte drehen Sie Ihr Gerät in den Hochformat-Modus!"},
	el_GR: {back: "Μετάβαση στον ιστότοπο", or: "Ή", turn: "Γυρίστε τη συσκευή σας σε κατακόρυφη προβολή!"},
	en_SC: {back: "Go to the website", or: "OR", turn: "Please turn your device to portrait mode!"},
	en_US: {back: "Go to the website", or: "OR", turn: "Please turn your device to portrait mode!"},
	es_ES: {back: "Volver al sitio web", or: "O", turn: "¡Por favor, gire su dispositivo al modo retrato!"},
	et_EE: {back: "Mine veebilehele", or: "VÕI", turn: "Palun pöörake oma seade püstasendisse!"},
	fa_IR: {back: "بازگشت به وب‌سایت", or: "یا", turn: "لطفاً دستگاه خود را به حالت عمودی بچرخانید!"},
	fi_FI: {back: "Siirry verkkosivustolle", or: "TAI", turn: "Käännä laitteesi pystytilaan!"},
	fr_FR: {back: "Aller sur le site", or: "OU", turn: "Veuillez tourner votre appareil en mode portrait!"},
	hr_HR: {back: "Idi na web stranicu", or: "ILI", turn: "Molimo okrenite uređaj u okomiti položaj!"},
	hu_HU: {back: "Ugrás a weboldalra", or: "VAGY", turn: "Kérjük, fordítsa el készülékét álló módba!"},
	hy_AM: {back: "Անցնել կայք", or: "ԿԱՄ", turn: "Խնդրում ենք սարքը պահել ուղղահայաց դիրքով!"},
	id_ID: {back: "Kembali ke situs", or: "ATAU", turn: "Silakan putar perangkat Anda ke mode potret!"},
	it_IT: {back: "Vai al sito web", or: "O", turn: "Ruota il dispositivo in modalità verticale!"},
	ja_JP: {back: "ウェブサイトへ戻る", or: "または", turn: "デバイスを縦向きにしてください！"},
	ka_GE: {back: "ვებსაიტზე გადასვლა", or: "ან", turn: "გთხოვთ, მოატრიალოთ მოწყობილობა პორტრეტულ რეჟიმში!"},
	ko_KR: {back: "웹사이트로 이동", or: "또는", turn: "기기를 세로 모드로 전환해 주세요!"},
	lt_LT: {back: "Grįžti į svetainę", or: "ARBA", turn: "Prašome pasukti įrenginį į vertikalią padėtį!"},
	lv_LV: {back: "Doties uz vietni", or: "VAI", turn: "Lūdzu, pagrieziet ierīci portretorientācijā!"},
	ms_MY: {back: "Pergi ke laman web", or: "ATAU", turn: "Sila putar peranti anda ke mod potret!"},
	nb_NO: {back: "Gå til nettstedet", or: "ELLER", turn: "Vennligst snu enheten til portrettmodus!"},
	nl_NL: {back: "Ga naar website", or: "OF", turn: "Draai je apparaat naar de staande stand!"},
	pl_PL: {back: "Przejdź do strony", or: "LUB", turn: "Obróć urządzenie do trybu pionowego!"},
	pt_BR: {back: "Ir para o site", or: "OU", turn: "Por favor, gire seu dispositivo para o modo retrato!"},
	pt_PT: {back: "Ir para o site", or: "OU", turn: "Por favor, gire seu dispositivo para o modo retrato!"},
	ro_RO: {back: "Mergi la site", or: "SAU", turn: "Vă rugăm să rotiți dispozitivul în modul portret!"},
	ru_RU: {back: "Назад на сайт", or: "ИЛИ", turn: "Поверните устройство в портретный режим!"},
	sk_SK: {back: "Prejsť na web", or: "ALEBO", turn: "Otočte zariadenie na výšku!"},
	sr_Latn: {back: "Idi na sajt", or: "ILI", turn: "Molimo okrenite uređaj u uspravni položaj!"},
	sv_SE: {back: "Gå till webbplatsen", or: "ELLER", turn: "Vänligen vänd din enhet till stående läge!"},
	th_TH: {back: "ไปที่เว็บไซต์", or: "หรือ", turn: "โปรดหมุนอุปกรณ์ของคุณเป็นแนวตั้ง!"},
	tr_TR: {back: "Siteye git", or: "VEYA", turn: "Lütfen cihazınızı dikey moda çevirin!"},
	uk_UA: {back: "На сайт", or: "АБО", turn: "Будь ласка, поверніть пристрій в портретний режим!"},
	vi_VN: {back: "Đến trang web", or: "HOẶC", turn: "Vui lòng xoay thiết bị sang chế độ dọc!"},
	zh_Hans: {back: "返回网站", or: "或", turn: "请将设备切换为竖屏模式！"},
	zh_Hant: {back: "返回網站", or: "或", turn: "請將裝置切換為直向模式！"}
};

export default {
	portrait,
	landscape,
	getMessages: (orientation, lang) => {
		const messages = orientation === "portrait" ? portrait : landscape;
		return messages[lang] || messages.en_US;
	}
};



// WEBPACK FOOTER //
// ./js/messages.js